export const refreshWindowLocation = () => {
    const router = useRouter();
    router.go(0);
}